import { createContext, useContext, useState } from 'react'

const AuthContext = createContext(null)

const MOCK_USER = {
  name: 'Ahmad Abdullah',
  initials: 'AA',
  email: 'ahmad@jkn.sarawak.gov.my',
  phone: '+60 12-345 6789',
  department: 'Jabatan Operasi',
  role: 'User / Member',
  accessSites: ['PDK', 'JKS', 'MBKU'],
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(
    localStorage.getItem('hd_token') ? MOCK_USER : null
  )

  const login = (email, password) => {
    // Mock — accept any non-empty credentials
    if (email && password) {
      localStorage.setItem('hd_token', 'mock-token-123')
      setUser(MOCK_USER)
      return true
    }
    return false
  }

  const logout = () => {
    localStorage.removeItem('hd_token')
    setUser(null)
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  return useContext(AuthContext)
}
